export const PAGE_LOAD_ATTEMPTS = 4;
export async function retryLoad(load, { attempts = PAGE_LOAD_ATTEMPTS, delayMs = 100, timeoutMs = 10000, shouldRetry = () => true } = {}) {
  for (let attempt = 1; attempt <= attempts; attempt++) {
    let timer;
    try {
      return await Promise.race([
        Promise.resolve(load()),
        new Promise((_, reject) => { timer = setTimeout(() => reject(Object.assign(new Error('Loading timed out'), { code: 'LOAD_TIMEOUT', retryable: true })), timeoutMs); }),
      ]);
    } catch (error) {
      if (attempt === attempts || !shouldRetry(error)) throw error;
    } finally { clearTimeout(timer); }
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }
}

